import { Component, input, output, computed, signal } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SearchTerm } from 'src/app/models/search-term';

@Component({
  selector: 'app-lt-search-card',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    JsonPipe,
  ],
  templateUrl: './lt-search-card.html',
  styleUrl: './lt-search-card.scss',
})
export class LTSearchCardComponent {
  // Input signals
  searchTerm = input.required<SearchTerm>();
  label = input<string>('Search');
  placeholder = input<string>('Search...');
  inputClass = input<string>('form-control');
  showCurrentSearch = input<boolean>(true);

  // Output signals
  searchUpdate = output<SearchTerm>();
  searchClear = output<SearchTerm>();

  // Local signals
  currentSearchValue = signal<string>('');
  hasActiveSearch = signal<boolean>(false);

  // Computed signals for better template performance
  effectivePlaceholder = computed(() =>
    this.searchTerm()?.defaultText || this.placeholder(),
  );

  hasSearchValue = computed(() => {
    const value = this.currentSearchValue().trim();
    return value.length > 0;
  });

  showSearchFooter = computed(() =>
    this.showCurrentSearch() && this.hasActiveSearch(),
  );

  onUpdateSearch(): void {
    const searchTerm = this.searchTerm();
    searchTerm.searchValue = this.currentSearchValue();
    searchTerm.save();
    this.hasActiveSearch.set(true);
    this.searchUpdate.emit(searchTerm);
  }

  onClearSearch(): void {
    this.currentSearchValue.set('');
    const searchTerm = this.searchTerm();
    searchTerm.clear();
    this.hasActiveSearch.set(false);
    this.searchClear.emit(searchTerm);
  }
}
